module.exports = __webpack_public_path__ + "static/media/sky.0ac245cb.svg";